const ColumnWidths = {
  DEFAULT: 200,
  SMALL: 150,
  XTRASMALL: 100,
  XXSMALL: 40,
  WIDTH60: 60,
  MEDIUM: 250,
  LARGE: 300,
  XTRALARGE: 350,
  MAX: 500,
};

export function flattenProductions(data: any) {
  const productionToChildMap: any = {};
  for (const element of data) {
    if (element.parentProductionId) {
      element.productiontype = 'Semi Finished Goods';
      if (productionToChildMap[element.parentProductionId]) {
        productionToChildMap[element.parentProductionId].push(element);
      } else {
        productionToChildMap[element.parentProductionId] = [element];
      }
    }
    else {
      element.productiontype = 'Finished Goods';
    }
  }
  const temp: any = [], result: any = [];
  for (const element of data) {
    if (productionToChildMap[element.id]) element.children = productionToChildMap[element.id];
    if (!element.parentProductionId) temp.push(element);
  }


  function processNode(node: any) {
    result.push({ ...node, children: null });
    const childIds = (node.children || []).map((c: any) => c.itemId);
    if (node?.children && node.children.length > 0) {
      node.children.forEach((child: any) => processNode(child));
    }
    if (node.rawMaterials && node.rawMaterials.length > 0) {
      node.rawMaterials.forEach((rm: any) => {
        if (!childIds.includes(rm.itemId)) {
          result.push({
            ...rm,
            productiontype: 'Raw Material',
            status: null,
            productionId: node.productionId,
            productionNavigationId: node.productionNavigationId,
            bomId: node.bomId,
            bomName: node.bomName,
            addDuringProduction: rm?.addDuringProduction ? 'Yes' : 'No',
            documentNumber: node.salesOrderNumber
          });
        }
      });
    }
  }

  temp.forEach((node: any) => processNode(node));
  return result;
}



export default ColumnWidths;

